import './Services.scss'

import { Link } from 'react-router-dom';

import celulares from '../../assets/img/bento/services/celulares.jpg'
import consolas from '../../assets/img/bento/services/consolas.jpg'
import parlantes from '../../assets/img/bento/services/parlantes.jpg'
import ipads from '../../assets/img/bento/services/tablets.jpg'
import smartWatch from '../../assets/img/bento/services/smartwatch.jpg'
import accesorios from '../../assets/img/bento/services/accesorios.jpg'
import auriculares from '../../assets/img/bento/services/auriculares.jpg'
import convertidor from '../../assets/img/bento/services/convertidor.jpg'

const Services = () => {
  return (
    <div className="services">
      <div className="wrapper">
        
        {/* <a href="#" style={{"--grid-area": "cat-sport"}}>
          <p className="align-right">Macbooks</p>
          <img src={macbooks} />
        </a> */}
        
        <Link to="/tienda/productos/vief" style={{"--grid-area": "cat-tees"}}>
          <p>Celulares</p>
          <img src={celulares} />
        </Link>
        
        {/* <a href="#" style={{"--grid-area": "cat-hoodies"}}>
          <p>Bicicletas</p>
          <img src={bicicletas} />
        </a> */}
        
        <Link to="/tienda/productos/cia9" style={{"--grid-area": "cat-ladies-shirt"}}>
          <p>Gamin</p>
          <img src={consolas} />
        </Link>
        
        <Link to="/tienda/productos/vytu/CATALOGO-Computacion-Table-y-Tabletas" style={{"--grid-area": "cat-youth"}}>
          <p>Tablets</p>
          <img src={ipads} />
        </Link>
        
        <Link to="/tienda/productos/d14n/CATALOGO-Smartwatch" style={{"--grid-area": "cat-kids"}}>
          <p>Smart Watch</p>
          <img src={smartWatch} />
        </Link>
        
        <Link to="/tienda/productos/otd2" style={{"--grid-area": "cat-cologne"}}>
          <p>Parlantes</p>
          <img src={parlantes} />
        </Link>
        
        <Link to="/tienda/productos/otd2" style={{"--grid-area": "cat-mens-shirts"}}>
          <p>Auriculares</p>
          <img src={auriculares} />
        </Link>
        
        <Link to="/tienda/productos/myvc" style={{"--grid-area": "cat-intimate"}}>
          <p>Convertirdor</p>
          <img src={convertidor} />
        </Link>
        
        <Link to="/tienda/productos/a24f" style={{"--grid-area": "banner"}} >
          <p>Accesorios</p>
          <img src={accesorios} />
        </Link>
        
      </div>
    </div>
  )
}
export default Services